import { useEffect, useState } from 'react';
import { X, Keyboard } from 'lucide-react';

const SHORTCUTS = [
  { keys: ['Ctrl', 'G'], desc: 'Open the awesome bar (jump to anywhere)' },
  { keys: ['Ctrl', 'K'], desc: 'Open the awesome bar (alternative)' },
  { keys: ['Ctrl', '/'], desc: 'Open the awesome bar (alternative)' },
  { keys: ['Ctrl', 'N'], desc: 'New record (on a doctype list page)' },
  { keys: ['Ctrl', 'S'], desc: 'Save current form' },
  { keys: ['\\'], desc: 'Toggle sidebar collapse' },
  { keys: ['Esc'], desc: 'Close modals / dropdowns' },
  { keys: ['?'], desc: 'Show this help' },
  { keys: ['/'], desc: 'Focus the search field on a list page' },
  { keys: ['g', 'h'], desc: 'Go to Home' },
  { keys: ['g', 'i'], desc: 'Go to Inbox' },
  { keys: ['g', 't'], desc: 'Go to ToDos' },
  { keys: ['g', 'd'], desc: 'Go to Dashboards' },
];

export default function KeyboardShortcutsModal() {
  const [open, setOpen] = useState(false);
  const [chord, setChord] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      const tag = (e.target?.tagName || '').toLowerCase();
      const inField = tag === 'input' || tag === 'textarea' || e.target?.isContentEditable;
      if (e.key === 'Escape' && open) { setOpen(false); return; }
      if (inField) return;
      if (e.key === '?') { e.preventDefault(); setOpen(true); return; }
      if (e.key === 'g') { setChord('g'); setTimeout(() => setChord(c => c === 'g' ? null : c), 1500); return; }
      if (chord === 'g') {
        const m = { h: '/', i: '/inbox', t: '/todos', d: '/erp-dashboards' };
        const dest = m[e.key.toLowerCase()];
        if (dest) { e.preventDefault(); window.location.assign(dest); setChord(null); }
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, chord]);

  if (!open) return null;
  return (
    <div role="dialog" aria-modal="true" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }} onClick={() => setOpen(false)}>
      <div style={{ background: 'var(--erp-surface)', borderRadius: 8, width: 480, maxHeight: '80vh', overflow: 'auto' }} onClick={e => e.stopPropagation()}>
        <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--erp-border)', display: 'flex', alignItems: 'center', gap: 8 }}>
          <Keyboard size={16} color="var(--erp-primary)" />
          <strong style={{ fontSize: 14 }}>Keyboard Shortcuts</strong>
          <button className="erp-icon-btn" style={{ marginLeft: 'auto' }} onClick={() => setOpen(false)}><X size={14} /></button>
        </div>
        <div style={{ padding: 16 }}>
          {SHORTCUTS.map((s, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '6px 0', borderBottom: i < SHORTCUTS.length - 1 ? '1px solid var(--erp-border)' : 'none' }}>
              <span style={{ fontSize: 13, color: 'var(--erp-text)' }}>{s.desc}</span>
              <span style={{ display: 'flex', gap: 4 }}>
                {s.keys.map((k, j) => (
                  <kbd key={j} style={{ fontSize: 11, padding: '2px 6px', background: 'var(--erp-surface-2)', border: '1px solid var(--erp-border)', borderRadius: 3, fontFamily: 'monospace' }}>{k}</kbd>
                ))}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
